import type { MbcBrandContext } from "@nlc/shared-types";

import type { MBCUIMessage } from "../types/mbc-chat.types";

const BRIEF_QUESTION =
  "Do you already have a brief, or would you like help writing one?";

const BRIEF_CHOICES = [
  { id: "has-brief", label: "I already have a brief" },
  { id: "needs-help", label: "Help me write one" },
];

function textMessage(
  id: string,
  role: "assistant" | "user",
  text: string,
): MBCUIMessage {
  return { id, parts: [{ text, type: "text" }], role };
}

/**
 * The brand step happens before the chat agent starts, but the customer's
 * choices should read as the opening of the conversation. This rebuilds those
 * choices as transcript bubbles so they show as chat entries above the agent's
 * first reply.
 */
export function buildGatePreamble(
  brand: MbcBrandContext | null,
): MBCUIMessage[] {
  const preamble: MBCUIMessage[] = [
    textMessage(
      "gate-greeting",
      "assistant",
      "Hi 👋 Let's build your brief together. Do you want to work with an existing brand or create a new one?",
    ),
    textMessage(
      "gate-choice",
      "user",
      brand ? "Use an existing brand" : "Continue without a brand",
    ),
  ];

  if (brand) {
    preamble.push(
      textMessage(
        "gate-brand-question",
        "assistant",
        "Great! Which brand are we creating the request for?",
      ),
      textMessage("gate-brand-answer", "user", brand.name),
    );
  }

  preamble.push({
    id: "gate-brief-question",
    parts: [
      { text: BRIEF_QUESTION, type: "text" },
      { data: { options: BRIEF_CHOICES }, type: "data-choices" },
    ],
    role: "assistant",
  });

  return preamble;
}
